/* global newrelic */
export const experienceHandler = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('app-render.uncaught_error', _ref => {
    let {
      output
    } = _ref;
    const {
      error
    } = output || {};
    newrelic.noticeError(error);
    newrelic.addPageAction('ExperienceError', {
      errorMessage: error === null || error === void 0 ? void 0 : error.message,
      errorStack: error === null || error === void 0 ? void 0 : error.stack
    });
  });
};
//# sourceMappingURL=app-render.listener.js.map